<template>
  <v-tooltip
      :disabled="disabled"
      :location="location"
      :transition="transition"
      v-bind="$attrs"
  >
    <template #activator="{props}">
      <slot name="activator" :props="props" />
    </template>
    <template #default>
      <slot name="default" />
    </template>
  </v-tooltip>
</template>

<script>
/**
 * A wrapper around the tooltip with a different default transition
 * All Vuetify props for the tooltip component are usable.
 * @see https://vuetifyjs.com/en/api/v-tooltip/#props
 */
export default {
  name: 'AppTooltip',
  inheritAttrs: false,
  props: {
    location: {
      type: String,
      validator (value) {
        return ['start', 'end', 'center', 'top', 'bottom', 'left', 'right'].includes(value)
      },
      default: 'top',
    },
    transition: {
      type: String,
      default: 'fade-transition',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<!--<docs>-->
<!--```vue-->
<!--<template>-->
<!--  <div class="d-flex">-->
<!--    <AppTooltip top>-->
<!--      <template #activator="{props}">-->
<!--      <span v-bind="props">-->
<!--        Some text-->
<!--      </span>-->
<!--      </template>-->
<!--      <span>My tooltip</span>-->
<!--    </AppTooltip>-->
<!--  </div>-->
<!--</template>-->
<!--```-->
<!--</docs>-->
